<template>
    <div class="regis">
        <div class="container">
            <img alt="logo kemnaker" src="@/assets/logo single.png" />
            <form action="#">
                <h2>Daftar Akun</h2>
                <p>Silahkan daftar akun terlebih dahulu</p>
                <label for="namabu">Nama Badan Usaha</label>
                <input type="text" name="namabu" id="">
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "RegisDash",
    props: {
        msg: String,
    },
};
</script>

<style>
img {
    width: 100px;
    height: 100px;
    object-fit: cover;
}

.regis {
    width: 100%;
    height: 100vh;
    background-color: transparent;
    display: flex;
    justify-content: center;
    /* horizontal */
    align-items: center;

    .container {
        background-color: white;
        width: max-content;
        padding: 20px;

        h2{
            text-align: center;
        }

        img{
            margin-left: 50%;
            transform: translateX(-50%);
        }
    }
}
</style>
